export enum LocalStorageId {
  cookiesAccepted = 'cookiesAccepted',
  abundanceMode = 'abundanceMode',
  teamBrowser = 'teamBrowser',
  // keep in sync with docs/public/scripts/header-nav.js handleLogout
  token = 'RESISTOMAP/TOKEN',
  organisationCreated = 'organisationCreated',
  overviewTutorialStep = 'overviewTutorialStep', // deprecated
  mobileNoticeShown = 'mobileNoticeShown',
  adminMode = 'adminMode',
  chartDisplayMode = 'chartDisplayMode',
  notifiedAssayVersion = 'notifiedAssayVersion',
  researchViewWelcomeShown = 'researchViewWelcomeShown',
  chipViewHighlightFlag = 'chipViewHighlightFlag',
  chipViewShowRejected = 'chipViewShowRejected',
  contextualTipsState = 'contextualTipsState',
  contextualTipsSnoozedUntil = 'contextualTipsSnoozedUntil',
}

export function storedToken() {
  const token = localStorage.getItem(LocalStorageId.token);
  return token?.replace(/^"(.*)"$/, '$1'); // use-local-storage-state jsonfies strings, while old versions of UI didn't
}

export function storedTeamBrowser() {
  return localStorage.getItem(LocalStorageId.teamBrowser) === 'true';
}

export function storedCookiesAccepted() {
  return localStorage.getItem(LocalStorageId.cookiesAccepted) === 'true';
}
